import { Pipe, PipeTransform } from "@angular/core";
import { PageInfo } from "../components/pagination/pagination.component";

@Pipe({
    name: 'pagesfilter',
    pure: false,
    standalone: false
})
export class FilterByPagesPipe implements PipeTransform
{
  transform(items: Array<any>, config: PageInfo): any
  {
    if (!items || !config) return [];

    return items.slice(config.itemsPerPage * (config.pageNumber - 1),
      Math.min(items.length, config.itemsPerPage * config.pageNumber));
  }
}
